<template>
  <div
    v-if="!props.paymentSuccessful"
    class="flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-end"
  >
    <el-button
      class="!m-0 w-full sm:w-auto"
      @click="onDecline"
    >
      {{ $t("COMMON.CLOSE_BTN") }}
    </el-button>
    <el-button
      v-if="!props.cancellationPending"
      type="danger"
      plain
      class="!m-0 w-full sm:w-auto"
      :loading="props.cancelLoading"
      :disabled="props.refreshLoading"
      @click="onCancelOrder"
    >
      {{ $t("PAYMENT_REMINDER.CANCEL_ORDER") }}
    </el-button>
    <el-button
      type="warning"
      class="!m-0 w-full sm:w-auto"
      :loading="props.refreshLoading"
      @click="onRefresh"
    >
      {{ props.refreshLoading
        ? $t("PAYMENT_REMINDER.REFRESHING")
        : $t("PAYMENT_REMINDER.REFRESH_STATUS") }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
type PropsType = {
  paymentSuccessful: boolean;
  refreshLoading: boolean;
  cancelLoading: boolean;
  cancellationPending: boolean;
};

const props = defineProps<PropsType>();
const emits = defineEmits(["decline", "refresh", "cancelOrder"]);

function onDecline() {
  emits("decline");
}

function onRefresh() {
  emits("refresh");
}

function onCancelOrder() {
  emits("cancelOrder");
}
</script>
